import api from "@/services/Api";

export default {
  async listOrder({}, params) {
    try {
      const { data } = await api.get("/orders", { params });
      return data;
    } catch (e) {
      return false;
    }
  },

  async getOrder({}, id) {
    try {
      const { data } = await api.get("/orders/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async insertOrder({}, form) {
    try {
      const { data } = await api.post("/orders", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async updateOrder({}, form) {
    try {
      const { data } = await api.post("/orders/" + form.get("id"), form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async destroyOrder({}, id) {
    try {
      const { data } = await api.delete("/orders/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },
};
